var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "fileDragDrop",
      class: {
        showOutline: _vm.showOutline || _vm.dragging,
        dragging: _vm.dragging,
      },
    },
    [
      _c(
        "div",
        { staticClass: "uploadContainer" },
        [
          _vm.dragging === false || !_vm.$slots.dragging
            ? _vm._t("default")
            : _vm._t("dragging"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }